module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Vocabulary *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.vocabularyOptionsDefault,
      "search-function": _vm.vocabularySearch,
      "label": "name"
    },
    model: {
      value: (_vm.entity.vocabulary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "vocabulary", $$v)
      },
      expression: "entity.vocabulary"
    }
  })], 1)]), _vm._v(" "), (_vm.entity.vocabulary) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Parent Term")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-select', {
    attrs: {
      "filterable": false,
      "options": _vm.parentOptions
    },
    on: {
      "search": _vm.onParentSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n                      " + _vm._s(option.name) + "\n                    ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n                      " + _vm._s(option.name) + "\n                    ")]
      }
    }], null, false, 2548199629),
    model: {
      value: (_vm.entity.parent),
      callback: function($$v) {
        _vm.$set(_vm.entity, "parent", $$v)
      },
      expression: "entity.parent"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("\n                      No results. Type to search...\n                    ")])], 2)], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Term has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Term")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-193ffcfc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/taxonomy/terms/New.vue
// module id = 828
// module chunks = 0